import { Box } from '@mui/material';
import type { ReactElement } from 'react';
import { filtersRendererGridSx } from '../styles';
import type { FilterTabPanelProps } from '../types';

export function FilterTabPanel({
  value,
  index,
  children,
}: FilterTabPanelProps): ReactElement {
  return (
    <Box
      sx={filtersRendererGridSx}
      role="tabpanel"
      hidden={value !== index}
      id={`chart-filters-tabpanel-${index}`}
      aria-labelledby={`chart-filters-tab-${index}`}
    >
      {value === index ? children : null}
    </Box>
  );
}
